// Per-container tokens so a new scroll animation supersedes a running one on the
// same element (rapid expand/switch), while keeping different grids independent.
const tokens = new WeakMap<HTMLElement, number>();

export const beginScrollAnimation = (el: HTMLElement): number => {
  const next = (tokens.get(el) ?? 0) + 1;
  tokens.set(el, next);
  return next;
};

export const isScrollAnimationCurrent = (
  el: HTMLElement,
  token: number
): boolean => tokens.get(el) === token;
